import React from 'react'
import { Wrapper } from './style.css'
const Start = ({ onStarted }) => {
  return (
    <Wrapper className="">
      <div className="p-4 text-center col1 ">
        <h2 className="text-4xl font-bold leading-none sm:text-5xl ">
          ¿Cuánto sabes sobre la Batidora planetaria de Philips?
          <small className="block text-2xl font-normal sm:text-xl">
            Ingresa a nuestra trivia y estarás participando en el sorteo de 1
            Batidora planetaria
          </small>
        </h2>
      </div>
      <div className="p-4 text-center">
        <button
          onClick={() => onStarted()}
          className="text-5xl font-bold underline sm:text-6xl md:text-6xl focus:outline-none ">
          Iniciar
        </button>
      </div>
    </Wrapper>
  )
}

export default Start
